import { styled } from '@mui/material/styles';
import { Box, Grid, LinearProgress, Paper, Typography } from '@mui/material';
import React from 'react';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  '& .Item-Head': {
    fontSize: '.7rem',
    background: '#f2f2f2',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: ' 0 8px 0 8px',
    borderRadius: '6px 6px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 500,
      color: '#333',
      fontSize: '.875rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(0.75, 1.5),
    color: '#13113c'
  }
}));

const getScoreColor = (score) => {
  if (score >= 80) return '#00AA00'; // Strong Buy - Wall Street Green
  if (score >= 65) return '#22c55e'; // Buy - Light Green
  if (score >= 50) return '#FFA500'; // Hold - Wall Street Orange/Amber
  if (score >= 35) return '#FF6B6B'; // Underperform - Light Red
  return '#DC2626'; // Sell - Wall Street Red
};

const ScoreMetric = ({ watchlist_metrics, ticker }) => {
  if (!watchlist_metrics || watchlist_metrics.length === 0 || !watchlist_metrics[0].SCORE_ALL) return null;

  const score = watchlist_metrics[0].SCORE_ALL;
  const scorePercentage = score; // Assuming score is already out of 100

  return (
    <Grid size={{ xs: 12, sm: 12 }} sx={{ maxWidth: { xs: '100%', md: '300px' } }}>
      <Item component="div" sx={{ mb: '8px' }}>
        <Box className="Item-Body" sx={{ display: 'flex', flexDirection: 'column', gap: .5, pt: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
              <Typography variant="h2" sx={{ fontSize: '2.5rem', fontWeight: 700, color: '#174c86', lineHeight: 1 }}>
                {score}<Typography component="span" sx={{ fontSize: '1.25rem', fontWeight: 400, color: '#666' }}>/100</Typography>
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
              <Typography variant="subtitle2" sx={{ fontSize: '.75rem', fontWeight: 600, color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1 }}>
                {ticker}
              </Typography>
              <Typography variant="subtitle2" sx={{ fontSize: '.75rem', fontWeight: 600, color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1 }}>
                STOCK SCORE
              </Typography>
            </Box>
          </Box>

          <Box sx={{ width: '100%' }}>
            <LinearProgress
              variant="determinate"
              value={scorePercentage}
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: '#e5e7eb',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: getScoreColor(score),
                  borderRadius: 4,
                }
              }}
            />
            <Typography variant="caption" sx={{ display: 'block', mt: 1, fontSize: '.7rem', color: '#666', lineHeight: 1.4, textAlign: 'center' }}>
              High Scoring Large Cap stocks have outperformed low scoring stocks by 90% over last 10 years
              {/* High-scoring large-cap stocks outperformed low-scoring by 90% over 10 years. */}
            </Typography>
          </Box>
        </Box>
      </Item>
    </Grid>
  );
}

export default React.memo(ScoreMetric);
